import React, { useState } from "react";
import { Route } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { SlFormEntryRow, TextInput, SlPageTitle, SlSectionLabel, SlButton } from "./editors";
import { IdentificationType } from "./subcomponents/IdentificationType";
import { metadataService, registrationService, userService } from "../_services";
import { PrivateRoute } from "./PrivateRoute";

export function GuestRoute({ component: Component, pageName, sectionName, ...extraProps }) {
    const [guestUserHash, setGuestUserHash] = useState(null);

    const sessionUser = userService.getCurrentUser();
    if (sessionUser !== null) {
        return <PrivateRoute component={Component} {...extraProps} />
    }

    if (!metadataService.isNullOrEmpty(guestUserHash)) {
        return (
            <Route {...extraProps} render={(props) => {
                return <Component userHash={guestUserHash} isGuest={true} { ...props } />
            }} />
        );
    }

    return (
        <Route {...extraProps} render={(_) => {
            return <VerifyGuestIdentity pageName={pageName} sectionName={sectionName} onVerified={(userHash) => setGuestUserHash(userHash)} />
        }} />
    )
}

function VerifyGuestIdentity({ pageName, sectionName, onVerified }) {
    const [isBusy, setIsBusy] = useState(false);
    const [message, setMessage] = useState(null);
    const [formValue, setFormValue] = useState({
        SocialSecurityNumber: '',
        DOB: '',
        IndividualTaxIdentificationNumber: '',
        identityType: '',
        useSSN: '',
        ssnItinError: true
    });

    const handleInput = ({ target: { name, value } }) => {
        let result = { ...formValue, [name]: value }
        if (name === "SocialSecurityItin") {
            if (value.SocialSecurityNumber) {
                result.SocialSecurityNumber = value.SocialSecurityNumber;
            }
            else if (value.IndividualTaxIdentificationNumber) {
                result.IndividualTaxIdentificationNumber = value.IndividualTaxIdentificationNumber;
            }

            result.ssnItinError = !value.isValid;
        }

        setFormValue(result)
    }

    const isIdentificationTypeValid = (fieldName, isValid) => {
        return { formError: !isValid, ssnItinError: !isValid }
    }

    const canMoveNext = () => {
        return !isBusy && formValue.DOB !== '' && !formValue.ssnItinError;
    }

    const handleNext = () => {
        setMessage(null);
        setIsBusy(true);
        registrationService.getUserHash({
            DateOfBirth: formValue.DOB,
            SSN: formValue.SocialSecurityNumber || formValue.IndividualTaxIdentificationNumber,
            VerifyHash: true
        }).then(response => {
            if (response.data) {
                onVerified(response.data);
            } else {
                setMessage(metadataService.getMessage("AccountNotFound"));
            }
            setIsBusy(false);
        });
    }

    return (
        <div>
            <SlPageTitle pageName={pageName || "ConfirmAccount"} />
            <Row>
                <Col xs={12} md={{ size: 8, offset: 2 }}>
                    <SlSectionLabel centered={true} sectionName={sectionName || "ConfirmAccount"} />
                </Col>
            </Row>
            <IdentificationType
                name={"SocialSecurityItin"}
                isRequired={true}
                showLabel={true}
                onChange={handleInput}
                isValid={isIdentificationTypeValid}
                requireReEntry={true}
            />
            <SlFormEntryRow className="text-input-label">
                <TextInput
                    name="DOB"
                    type="date"
                    label={metadataService.getFieldNameLabel("DOB")}
                    onChange={handleInput}
                    value={formValue.DOB}
                    maskOnBlur={true}
                />
            </SlFormEntryRow>
            <div className="text-center">
                <SlButton name={isBusy ? "Processing" : "Next"} onClick={handleNext} disabled={!canMoveNext()} />
                { message != null && <p className="text-danger">{message}</p> }
            </div>
        </div>
    )
}
